import {
    IconAlertTriangle,
    IconEdit,
    IconClipboard,
    IconFileUpload,
    IconZoom,
    IconCircleCheck,
    IconCircleX,
    IconArrowBackUp,
    IconCheck,
} from '@tabler/icons-react';

// icon / color are presentation data and stay untranslated; `key` points at the
// `chargebacks.events.*` branch of the banking catalogue. color: 'alert' |
// 'info' | 'success' | 'error' | 'default'
const EVENT_DATA = {
    created: {
        key: 'created',
        icon: IconAlertTriangle,
        color: 'alert',
    },
    updated: {
        key: 'updated',
        icon: IconEdit,
        color: 'default',
    },
    evidence_required: {
        key: 'evidenceRequired',
        icon: IconClipboard,
        color: 'alert',
    },
    evidence_submitted: {
        key: 'evidenceSubmitted',
        icon: IconFileUpload,
        color: 'info',
    },
    under_review: {
        key: 'underReview',
        icon: IconZoom,
        color: 'info',
    },
    won: {
        key: 'won',
        icon: IconCircleCheck,
        color: 'success',
    },
    lost: {
        key: 'lost',
        icon: IconCircleX,
        color: 'error',
    },
    reversed: {
        key: 'reversed',
        icon: IconArrowBackUp,
        color: 'default',
    },
    closed: {
        key: 'closed',
        icon: IconCheck,
        color: 'default',
    },
    warning: {
        key: 'warning',
        icon: IconAlertTriangle,
        color: 'alert',
    },
};

const EVENT_FALLBACK = {
    icon: IconAlertTriangle,
    color: 'default',
};

// `t` is injected by the component (it belongs to the "banking" namespace), so
// the labels resolve at render time and follow the active language.
export function getChargebackEvent(t, type) {
    const config = EVENT_DATA[type];

    if (!config) {
        return {
            ...EVENT_FALLBACK,
            label: type || t('chargebacks.events.unknown.label'),
            description: '',
        };
    }

    return {
        icon: config.icon,
        color: config.color,
        label: t(`chargebacks.events.${config.key}.label`),
        description: t(`chargebacks.events.${config.key}.description`),
    };
}

export const getActorLabels = (t) => ({
    provider: t('chargebacks.actors.provider'),
    seller: t('chargebacks.actors.seller'),
    buyer: t('chargebacks.actors.buyer'),
    system: t('chargebacks.actors.system'),
});

export function getActorLabel(t, actor) {
    return getActorLabels(t)[actor] || actor || '';
}

export default EVENT_DATA;
